import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState = {
    sidebarOpen: false,
    expandedSidebarSections: {},
    workoutSummaryParameters: {
        userId: null,
        workoutId: null
    }
}

// Navigation Slice
const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload;
        },
        setSidebarSectionExpanded: (state, action) => {
            const { section, expanded } = action.payload

            if (!state.expandedSidebarSections) {
                state.expandedSidebarSections = {}
            }

            state.expandedSidebarSections[section] = expanded
        },
        setWorkoutSummaryParameters: (state, action) => {

            const { userId, workoutId } = action.payload

            if (!state.workoutSummaryParameters) {
                state.workoutSummaryParameters = {
                    userId: null,
                    workoutId: null
                }
            }

            state.workoutSummaryParameters.userId = userId;
            state.workoutSummaryParameters.workoutId = workoutId;

        },
        resetNavigationState: (state) => {
            const expandedSidebarSections = { ...(state.expandedSidebarSections || {}) }

            return {
                ...initialState,
                expandedSidebarSections
            }
        }
    },
});

export const {
    setSidebarOpen,
    setSidebarSectionExpanded,
    setWorkoutSummaryParameters,
    resetNavigationState
} = navigationSlice.actions;

export default navigationSlice.reducer;